import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./RefillQuantity.module.css";
import FixaToggle from "@coworker/apprestructured/src/shared/wrappers/FixaToggle/FixaToggle";
import {
  RefillUnitInputPanel,
  RefillUnitInputPanelProps,
} from "./RefillUnitInputPanel/RefillUnitInputPanel";
import { Trans } from "@coworker/locales";
import { UnitType } from "./constants";

type RefillQuantityProps = {
  activeUnit: UnitType;
  onUnitChange: (unit: UnitType) => void;
  panelConfigs: {
    label: string;
    panelProps: RefillUnitInputPanelProps;
  }[];
};

function RefillQuantity({
  activeUnit,
  onUnitChange,
  panelConfigs,
}: RefillQuantityProps) {
  return (
    <div className={styles["refillQuantity"]}>
      <FixaText textStyle="Heading.XS">
        <Trans>refillQuantityString</Trans>
      </FixaText>
      <FixaToggle
        buttons={panelConfigs.map((cfg) => ({ text: cfg.label }))}
        activeIndex={activeUnit}
        onClick={(_e, index) => onUnitChange(index)}
        className={styles["unitToggle"]!}
      />
      {panelConfigs[activeUnit] && (
        <RefillUnitInputPanel {...panelConfigs[activeUnit].panelProps} />
      )}
    </div>
  );
}

export default RefillQuantity;
